import '.c{display:flex;}.ssr-plugin'
import '.g{flex-direction:column;}.ssr-plugin'
import '.a6{align-items:stretch;}.ssr-plugin'
import '.ad{box-shadow:0px 0px 15px 0px rgba(0, 0, 0, 0.15);}.ssr-plugin'
import '.ae{border-radius:1.25rem;}.ssr-plugin'
import '.af{background-color:var(--palette-white);}.ssr-plugin'
import '.aw{overflow-y:hidden;}.ssr-plugin'
import '.c8{padding:1rem 1.5rem;}.ssr-plugin'
import '.c9{background:var(--palette-white);}.ssr-plugin'
import '.v{justify-content:space-between;}.ssr-plugin'
import '.h6{padding:0rem 1.5rem 2rem;}.ssr-plugin'
import '.h7{max-height:80vh;}.ssr-plugin'
import '.at{overflow-y:auto;}.ssr-plugin'
import '.ch{justify-content:flex-end;}.ssr-plugin'
import '.a0{gap:1rem;}.ssr-plugin'
import { styled } from 'inlines'
import { ReactNode } from 'react'
import { Button } from '@app/components/core/button/Button'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { useTranslations } from '@i18n/useLanguage'
import { ModalWrapper } from './ModalWrapper'
import useMediaQuery from '@app/util/useMediaQuery'

export type ModalProps = {
  children: ReactNode
  isOpen: boolean
  title?: string
  loading?: boolean
  renderContainer?: HTMLElement
  onClose: () => void
  onConfirm?: () => void
}

export const Modal = ({
  children,
  isOpen,
  loading,
  title,
  renderContainer,
  onClose,
  onConfirm,
}: ModalProps) => {
  // Always call hooks first
  const translations = useTranslations().app.common
  const isMobile = useMediaQuery()
  // Early return after hooks
  if (!isOpen) {
    return null
  }
  const content = (
    <div className="c g a6 ad ae af aw"
      style={{
        maxWidth: isMobile ? '90vw' : 'var(--max-width-modal)',
      }}
    >
      <div className="c c8 c9 v"
      >
        <Title.H5>{title ?? translations.attention}</Title.H5>
        <CloseButton onClick={onClose} size="small" />
      </div>
      <div className="c g h6 c9 h7 at"
      >
        {children}
      </div>
      <div className="c c8 c9 ch a0"
      >
        <Button
          label={translations.back}
          onClick={onClose}
          variant="secondary"
        />
        {onConfirm && (
          <Button
            label={translations.continue}
            onClick={onConfirm}
            disabled={loading}
          />
        )}
      </div>
    </div>
  )

  return (
    <ModalWrapper renderContainer={renderContainer}>{content}</ModalWrapper>
  )
}
